// Copyright (c) 2016 Deere & Company

import SelectedDealers, {getDefaultState} from '../state/selected-dealers';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const updateSelectedDealers = (state, action) =>
    SelectedDealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const updateSelectAllDealers = (state, action) => {

    const dealers = state.length ? [] : action.dealers;

    return SelectedDealers.update(state, {
        $set: dealers
    });

};

const updateAllDealersOnLoad = (state, action) =>
    SelectedDealers.update(state, {
        $set: action.dealers
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.SELECT_ALL_DELIVERY_NO_DOCUMENTS_DEALERS]: updateSelectAllDealers,
        [actions.SELECT_ALL_DELIVERY_NO_DOCUMENTS_DEALERS_ON_LOAD]: updateAllDealersOnLoad,
        [actions.SELECT_DELIVERY_NO_DOCUMENTS_DEALER]: updateSelectedDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/reducers/selected-dealers.js